<template>
    <div v-dusk="'alerts-zone'" class="alerts-zone alert" :class="['alert-' + type]">
        <span v-if="title" class="alert-heading h4">
            <i class="fad fa-exclamation-triangle"></i> {{ title }}
        </span>
        <ul :class="title ? 'mt-2' : ''">
            <li v-for="message in messages">{{ message }}</li>
        </ul>
    </div>
</template>

<script>

export default {
    name: 'AlertsZone',

    props: {
        type: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: false,
        },
        messages: {
            type: Array,
            required: true,
        },
    },
}

</script>
